import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityPaisesState,
  entityPaisesAdapter
} from './entity-paises.state';
import {
  entityPaisesLoadFailure,
  entityPaisesLoadRequest,
  entityPaisesLoadSuccess
} from './entity-paises.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityPaisesLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPaisesLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPaisesLoadSuccess, (state, { items }) =>
    entityPaisesAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function paisesReducer(
  state: EntityPaisesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
